exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide {\n  display: none !important;\n}\ndiv[col-id='checked'] {\n  pointer-events: all !important;\n}\n.asignacionNoSeriado .estilo-grilla,\n.asignacionNoSeriado #gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.asignacionNoSeriado .ag-pinned-right-cols-container,\n.asignacionNoSeriado .ag-pinned-right-header,\n.asignacionNoSeriado .ag-horizontal-right-spacer,\n.asignacionNoSeriado .ag-pinned-left-cols-container,\n.asignacionNoSeriado .ag-pinned-left-header,\n.asignacionNoSeriado .ag-horizontal-left-spacer {\n  display: none;\n}\n", ""]);

// exports
